//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('freightRateSets', {
//        templateUrl: 'views/components/views/freightRateSets/freightRateSets.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'freightRateSetsService', function ($stateParams, stateService, freightRateSetsService) {
//            const vm = this;
//            let custNo = $stateParams.cust_no;
            
//            vm.model = {
//                setting: {},
//                itemsListRateSets: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await freightRateSetsService.getSetting({ cust_no: custNo }))[0];
//            }

//            async function loadViews() {
//                vm.model.itemsListRateSets = await freightRateSetsService.listViews({ cust_no: custNo });
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'freightratesetcreate':
//                        go({ cust_no: custNo });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = async function () {
//                loadSetting();
//                loadViews();
//            }
//        }]
//    });
//})();
